export const examAdminAuditLogs = {
  titleAll: "Audit Logs",
  titleLogin: "Login Logs",
  titleOperation: "Operation Logs",
  subtitleAll: "Audit trail covering primary write operations",
  subtitleLogin: "Show authentication module logs only",
  subtitleOperation: "Show operation logs except authentication",
  drawer: {
    title: "Log #{id}",
    detailJson: "detail_json",
    technicalFields: "Technical Fields (Debug)",
  },
  columns: {
    id: "ID",
    time: "Time",
    actor: "Operator",
    loginResult: "Login Result",
    loginAudience: "Login Audience",
    loginIp: "Login IP",
    loginResolution: "Resolution",
    loginUa: "Browser UA",
    loginOs: "Operating System",
    loginBrowser: "Browser",
    loginDpr: "Pixel Ratio",
    loginTimezone: "Time Zone",
    loginLanguage: "Language",
    failureReason: "Failure Reason",
    operationResult: "Result",
    operationIp: "Operation IP",
    operationUa: "Browser UA",
    xForwardedFor: "Forwarded IP Chain",
    xRealIp: "Real IP",
    referer: "Referer",
    origin: "Origin",
    module: "Module",
    action: "Action",
    resource: "Resource",
    relation: "Relation",
    objectType: "Object Type",
    objectIdentifier: "Object Identifier",
    summary: "Summary",
  },
  audience: {
    staff: "Exam Staff",
    candidate: "Candidate",
  },
  stats: {
    total: "{count} logs",
    moduleCount: "Modules",
    resultGroup: "Result",
    audienceGroup: "Login identity",
    summaryUnavailable:
      "Audit legend counts failed to load; legend counts are unavailable",
  },
  result: {
    success: "Success",
    failed: "Failed",
    unknown: "Unknown",
  },
  actions: {
    updateUserPreferences: "Update user preferences",
  },
  meta: {
    os: {
      windows: "Windows",
      macos: "macOS",
      android: "Android",
      ios: "iOS",
      linux: "Linux",
      other: "Other",
    },
    browser: {
      edge: "Edge",
      chrome: "Chrome",
      firefox: "Firefox",
      safari: "Safari",
      other: "Other Browser",
    },
  },
  filters: {
    actorUserId: "Operator ID",
    module: "Module",
    action: "Action",
    resourceType: "Resource Type",
    resourceId: "Resource ID",
    examId: "Exam ID",
    attemptId: "Attempt ID",
    limit: "Limit",
  },
};
